/**
 * One image per player color — reused for all 4 tokens of that color.
 * Replace files in src/assets/ludo/tokens/ (keep the same filenames).
 */
import redToken from '../../assets/ludo/tokens/Reddice.png';
import blueToken from '../../assets/ludo/tokens/bluedice.png';
import greenToken from '../../assets/ludo/tokens/Greendice.png';
import yellowToken from '../../assets/ludo/tokens/Yallowdice.png';

export const TOKEN_IMAGES = {
  red: redToken,
  blue: blueToken,
  green: greenToken,
  yellow: yellowToken,
};

export function getTokenImage(color) {
  return TOKEN_IMAGES[color] ?? null;
}
